const countryFlags = {
  'NL': '🇳🇱',
  'BE': '🇧🇪'
};

function setLocationInfo(countryCode) {
  let shippingMessage = countryFlags[countryCode];
  if (countryCode == "NL" || countryCode == "BE") {
    const shipTopHtml = document.querySelector('#ship_top_html');
    if (shipTopHtml) {
      shipTopHtml.innerHTML = shippingMessage;
    }
  }
}

async function fetchLocationInfo() {
  try {
    const response = await fetch('/browsing_context_suggestions.json');
    const data = await response.json();
    const countryCode = data.detected_values.country.handle;
    setLocationInfo(countryCode);
  } catch (error) {
    console.error('Error fetching location info:', error);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  fetchLocationInfo();
});

document.addEventListener('cart:change', function () {
  fetchLocationInfo();
});

// hide collection from UK
if (
  window.location.pathname === '/collections/incontinentie' &&
  window.Shopify &&
  Shopify.country === 'GB'
) {
  window.location.replace('/');
}